import React, { lazy, Suspense } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import checkAuth from "../../src/app/auth";
import AdminLayout from "../layouts/AdminLayout";
import Coupons from "../components/pages/Coupons";
import AddCoupons from "../components/pages/AddCoupons";
import User from "../components/pages/user/User";
import AddUser from "../components/pages/user/AddUser";
import Transaction from "../components/pages/transaction/Transaction";
import Booking from "../components/pages/transaction/Booking";
import BookingDetail from "../components/pages/transaction/BookingDetail";
import Configuration from "../components/pages/configurations/Configuration";
import AddConfiguration from "../components/pages/configurations/AddConfiguration";
import TourAndPackages from "../components/package/TourAndPackages";
import PackageList from "../components/package/PackageList";
import ManageAirportDestinationsList from "../components/airportDestinations/ManageAirportDestinationsList";
import AddManageAirportDestinations from "../components/airportDestinations/AddManageAirportDestinations";
import PopularAirPortDestination from "../components/airportDestinations/PopularAirPortDestination";
import AddPopularAirPortDestination from "../components/airportDestinations/AddPopularAirPortDestination";
import CategoryList from "../components/package/CategoryList";
import AddCategory from "../components/package/AddCategory";
import Adddestination from "../components/package/Adddestination";
import DestinationsList from "../components/package/DestinationsList";
import EnquiryList from "../components/pages/configurations/EnquiryList";
import HotelBooking from "../layouts/HotelBooking";
import HolidayBookings from "../layouts/HolidayBookings";
import FlightBookings from "../components/pages/transaction/Booking";
import PriceList from "../components/pages/PriceList";
import HotelBookings from "../layouts/HotelBooking";
import BookingHotelDetail from "../components/pages/transaction/BookingHotelDetail";
import HotelPriceList from "../components/pages/HotelPriceList";
import ConvenienceFeesAndChargesList from "../components/conveniencefeesCharges/ConvenienceFeesAndCharges";
import AddConvenienceFeesAndCharges from "../components/conveniencefeesCharges/AddConvenienceFeesAndCharges";
import PriceFareRuleList from "../components/pricefarerule/PriceFareRuleList";
import AddPriceFareRuleList from "../components/pricefarerule/AddPriceFareRuleList";
import LogRequest from "../components/pages/transaction/LogRequest";
import HiddenFareRuleList from "../components/hiddenfare/HiddenFareRuleList";
import AddFareRule from "../components/hiddenfare/AddFareRule";
import TboHotelList from "../components/hotel/TboHotelList";
import SyncTboHotelList from "../components/hotel/SyncTboHotels";
import AddCitySync from "../components/hotel/AddCitySync";
import Traveller from "../components/pages/user/Traveller";
import AddTraveller from "../components/pages/user/AddTraveller";
import ManageHotelCityList from "../components/hotel/ManageHotelCityList";
import AddHotelCityMetaData from "../components/hotel/AddHotelCityMetaData";
import Feedbacks from "../components/package/Feedbacks";
import AddFeedback from "../components/package/AddFeedback";
import FlightBannerList from "../components/banners/FlightBannerList";
import AddFlightBanner from "../components/banners/addFlightBanner";
import AddOffersManagementPage from "../components/offerspages/AddOffersManagementPage";
import OffersManagementList from "../components/offerspages/OffersManagementList";



const Dashboard = lazy(() => import("../layouts/Dashboard"));

function AdminRouter() {
  const isAuthenticated = checkAuth();
  // popular-airPort-destination
  return (
    <Router>
      <Routes>
        <Route element={<AdminLayout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/coupons" element={<Coupons />} />
          <Route path="/add-coupons" element={<AddCoupons />} />
          <Route path="/edit-coupons/:id" element={<AddCoupons />} />
          <Route path="/user-list" element={<User />} />
          <Route path="/guest-list" element={<Traveller />} />
          <Route path="/edit/:id" element={<AddTraveller />} />
          <Route path="/add-user" element={<AddUser />} />
          <Route path="/edit-user/:id" element={<AddUser />} />
          <Route path="transaction" element={<Transaction />} />
          <Route path="/flight-bookings" element={<FlightBookings />} />
          <Route path="/log-list" element={<LogRequest />} />
          <Route path="/booking-detail/:id" element={<BookingDetail />} />
          <Route path="/hotel-booking-details/:id" element={<BookingHotelDetail />} />
          <Route path="/configurations" element={<Configuration />} />
          <Route path="/add-configuration" element={<AddConfiguration />} />
          <Route path="/edit-configuration/:id" element={<AddConfiguration />} />
          <Route path="/add-tour-and-packages" element={<TourAndPackages />} />
          <Route path="/manage-airport-destinations-list" element={<ManageAirportDestinationsList />} />
          <Route path="/add-manage-airport-destinations" element={<AddManageAirportDestinations />} />
          <Route path="/edit-manage-airport-destinations/:id" element={<AddManageAirportDestinations />} />
          <Route path="/edit-package/:id" element={<TourAndPackages />} />
          <Route path="/package-list" element={<PackageList />} />
          <Route path="/category-list" element={<CategoryList />} />
          <Route path="/add-category" element={<AddCategory />} />
          <Route path="/edit-category/:id" element={<AddCategory />} />
          <Route path="/destination-list" element={<DestinationsList />} />
          <Route path="/add-destination" element={<Adddestination />} />
          <Route path="/edit-destination/:id" element={<Adddestination />} />
          <Route path="/hotel-bookings" element={<HotelBookings />} />
          <Route path="/holiday-bookings" element={<HolidayBookings />} />

          <Route path="/convenience-fees-and-charges-list" element={<ConvenienceFeesAndChargesList />} />
          <Route path="/add-convenience-fees-and-charges" element={<AddConvenienceFeesAndCharges />} />
          <Route path="/edit-convenience-fees-and-charges/:id" element={<AddConvenienceFeesAndCharges />} />

          <Route path="/price-fare-rule" element={<PriceFareRuleList />} />
          <Route path="/add-price-fare-rule" element={<AddPriceFareRuleList />} />
          <Route path="/edit-price-fare-rule/:id" element={<AddPriceFareRuleList />} />


          <Route path="/price-list" element={<PriceList />} />
          <Route path="/popular-airPort-destination" element={<PopularAirPortDestination />} />
          <Route path="/add-popular-airPort-destination" element={<AddPopularAirPortDestination />} />
          <Route path="/edit-popular-airPort-destination/:id" element={<AddPopularAirPortDestination />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
          <Route path="/hotel-price-list" element={<HotelPriceList />} />

          <Route path="/hidden-fare-rule-list" element={<HiddenFareRuleList />} />
          <Route path="/add-hidden-fare-rule" element={<AddFareRule />} />
          <Route path="/add-hidden-fare-rule" element={<AddFareRule />} />
          <Route path="/edit-hidden-fare-rule/:id" element={<AddFareRule />} />
          <Route path="/tbo-hotels" element={<TboHotelList />} />
          <Route path="/sync-tbo-hotels" element={<SyncTboHotelList />} />
          <Route path="/add-city-to-sync" element={<AddCitySync />} />

          <Route path="/manage-hotel-city-list" element={<ManageHotelCityList />} />
          <Route path="/add-hotel-city-meta-data" element={<AddHotelCityMetaData />} />
          <Route path="/edit-hotel-city-meta-data/:id" element={<AddHotelCityMetaData />} />

          <Route path="/add-feedback" element={<AddFeedback />} />
          <Route path="/edit-feedback/:id" element={<AddFeedback />} />
          <Route path="/feedbacks" element={<Feedbacks />} />

          <Route path="/add-flight-banner" element={<AddFlightBanner />} />
          <Route path="/edit-flight-banner/:id" element={<AddFlightBanner />} />
          <Route path="/flight-banner" element={<FlightBannerList />} />

          <Route path="/add-offers-management" element={<AddOffersManagementPage />} />
          <Route path="/edit-offers-management/:id" element={<AddOffersManagementPage />} />
          <Route path="/offers-management-list" element={<OffersManagementList />} />

        </Route>
      </Routes>
    </Router>
  );
}

export default AdminRouter;
